module.exports = __webpack_public_path__ + "media/bossac.6f22b5ee.mp3";